import { ActionStatus } from 'thunkless';
import produce from 'immer';

import { ReferralTypes } from '../actions/referrals';

export interface ReferralCodeData {
  code: string | null;
  shareUrl: string | null;
}

export interface ReferralItem {
  id: number;
  referredOrgName: string;
  referredAdminEmail: string | null;
  status: string;
  referrerRewardAmount: number | null;
  referredRewardAmount: number | null;
  upgradedAt: string | null;
  rewardedAt: string | null;
  createdAt: string;
}

export interface ReferralSummary {
  signups: number;
  upgrades: number;
  balanceEarned: number;
}

export interface ReferralsState {
  codeLoadingStatus: ActionStatus | null;
  generateCodeStatus: ActionStatus | null;
  referralsLoadingStatus: ActionStatus | null;
  referralCode: ReferralCodeData | null;
  referrals: ReferralItem[];
  summary: ReferralSummary | null;
}

export const initialState: ReferralsState = {
  codeLoadingStatus: null,
  generateCodeStatus: null,
  referralsLoadingStatus: null,
  referralCode: null,
  referrals: [],
  summary: null,
};

export const reducer = produce((draft: ReferralsState, action: any) => {
  switch (action.type) {
    case ReferralTypes.GET_REFERRAL_CODE_REQUEST:
      draft.codeLoadingStatus = ActionStatus.BUSY;
      break;
    case ReferralTypes.GET_REFERRAL_CODE_SUCCESS:
      draft.codeLoadingStatus = ActionStatus.SUCCESS;
      draft.referralCode = action.payload.data;
      break;
    case ReferralTypes.GET_REFERRAL_CODE_FAILURE:
      draft.codeLoadingStatus = ActionStatus.FAILURE;
      break;

    case ReferralTypes.GENERATE_REFERRAL_CODE_REQUEST:
      draft.generateCodeStatus = ActionStatus.BUSY;
      break;
    case ReferralTypes.GENERATE_REFERRAL_CODE_SUCCESS:
      draft.generateCodeStatus = ActionStatus.SUCCESS;
      draft.referralCode = action.payload.data;
      break;
    case ReferralTypes.GENERATE_REFERRAL_CODE_FAILURE:
      draft.generateCodeStatus = ActionStatus.FAILURE;
      break;

    case ReferralTypes.GET_REFERRALS_REQUEST:
      draft.referralsLoadingStatus = ActionStatus.BUSY;
      break;
    case ReferralTypes.GET_REFERRALS_SUCCESS:
      draft.referralsLoadingStatus = ActionStatus.SUCCESS;
      draft.referrals = action.payload.data;
      draft.summary = action.payload.summary;
      break;
    case ReferralTypes.GET_REFERRALS_FAILURE:
      draft.referralsLoadingStatus = ActionStatus.FAILURE;
      break;
  }
}, initialState);
